import { apiClient, updateApiClientBaseUrl } from '../base_url/config'
import brandManager from '../services/brandManager'
import { applyCountryConfigFromCollection } from '../services/countryConfigService'

interface SettingsResponse {
  header_logo: string
  primary_color: string
  secondary_color: string
  fav_icon: string
  restaurant_name: string
  canOrder: boolean
}

const parseCanOrder = (value: unknown): boolean => {
  if (value === true || value === 1 || value === "1" || value === "true" || value === "True") {
    return true
  }
  if (value === false || value === 0 || value === "0" || value === "false" || value === "False") {
    return false
  }
  return true
}

export const fetchSettings = async (): Promise<SettingsResponse> => {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const branchId = urlParams.get("branchId") || "1"

    const response = await apiClient.get("/qr/settings", {
      params: { branchId: parseInt(branchId) },
    })

    const responseData = response.data?.data || response.data || {}
    brandManager.updateFromApi(responseData)
    updateApiClientBaseUrl()
    
    // Transform the API response to the expected format
    const settings = responseData.collection || []

    // Country/currency from Settings only — reuse this same bootstrap fetch.
    applyCountryConfigFromCollection(settings)

    const canOrderRaw =
      settings.find((item: any) => item.key === "canOrder")?.value ??
      responseData.canOrder

    const transformedSettings: SettingsResponse = {
      header_logo: settings.find((item: any) => item.key === "header_logo")?.value || brandManager.currentLogoUrl,
      primary_color: settings.find((item: any) => item.key === "primary_color")?.value || brandManager.currentPrimaryColor,
      secondary_color: settings.find((item: any) => item.key === "secondary_color")?.value || brandManager.currentSecondaryColor,
      fav_icon: settings.find((item: any) => item.key === "fav_icon")?.value || "/logo.svg",
      restaurant_name: settings.find((item: any) => item.key === "restaurant_name")?.value || brandManager.currentAppName,
      canOrder: parseCanOrder(canOrderRaw),
    }

    return transformedSettings
  } catch (error) {
    // Return default values if API fails — do not invent country from brand.
    // Failure here must never trigger Offline mode.
    return {
      header_logo: brandManager.currentLogoUrl,
      primary_color: brandManager.currentPrimaryColor,
      secondary_color: brandManager.currentSecondaryColor,
      fav_icon: "/logo.svg",
      restaurant_name: brandManager.currentAppName,
      canOrder: true,
    }
  }
}
